import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngCardListComponent } from './kng-card-list.component';
import { KngCardListService } from './kng-card-list.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
@NgModule({
	declarations: [KngCardListComponent],
	imports: [
		CommonModule,
		MatMenuModule,
		MatIconModule,
		MatButtonModule,
		MatTooltipModule,
		NgxPaginationModule,
		FormsModule,
		ReactiveFormsModule,
		MatSelectModule,
		MatCheckboxModule
	],
	exports: [KngCardListComponent],
	providers: [KngCardListService]
})
export class KngCardListModule {}
